'use client';

import IconsSprites from '@/components/IconsSprites';
import SearchField from '@/components/SearchForm/SearchField';
import SelectedFilters from '@/components/SearchForm/SelectedFilters';
import useSearchForm, { UseSearchFormProps } from '@/components/SearchForm/useSearchForm';
import React from 'react';

const SearchFormKD: React.FC<UseSearchFormProps> = ({
  fromHomePage,
  q,
  l,
  baseUrl,
  queryParameters,
  scrollElementId,
  locations,
  occupations,
  industries,
  seniorities,
}) => {
  const {
    keyword,
    location,
    locationSuggestions,
    keywordSuggestions,
    isKeywordsSuggestionsOpened,
    isLocationsSuggestionsOpened,
    setIsKeywordsSuggestionsOpened,
    setIsLocationsSuggestionsOpened,
    onSubmit,
    onFormKeyDown,
    onKeywordChange,
    onLocationChange,
    cancelKeywordSearch,
    cancelLocationSearch,
    onKeywordSuggestionsClick,
    onLocationSuggestionsClick,
    multipleLocations,
    getRemoveFilterHref,
  } = useSearchForm({
    fromHomePage,
    q,
    l,
    baseUrl,
    queryParameters,
    scrollElementId,
    locations,
    occupations,
    industries,
    seniorities,
  });

  return (
    <div className="bg-white p-4 custom-shadow-kd rounded-2xl mt-7">
      <IconsSprites />
      <form
        className={'flex flex-col gap-2.5 lg:flex-row lg:justify-center lg:items-center'}
        onSubmit={onSubmit}
        onKeyDown={onFormKeyDown}
      >
        <SearchField
          key="q-input"
          ariaLabel="Search jobs"
          icon="#lens"
          name="q"
          id="q"
          placeholder={'Job title, keyword, or company'}
          maxLength={200}
          minLength={1}
          value={keyword}
          onChange={onKeywordChange}
          cancelSearch={cancelKeywordSearch}
          suggestions={keywordSuggestions}
          onSuggestionsClick={onKeywordSuggestionsClick}
          isSuggestionsOpened={isKeywordsSuggestionsOpened}
          setIsSuggestionsOpened={setIsKeywordsSuggestionsOpened}
          className="w-full flex-col"
          classNames={{
            input: `py-3.25 pl-9! px-3 rounded-lg! lg:w-full bg-kd-athens-gray max-md:text-base md:text-sm outline-transparent border border-kd-geyser placeholder-kd-pale-sky focus-visible:border-kd-persimmon focus-visible:bg-white focus-visible:outline-kd-persimmon focus-visible:outline-1`,
            suggestions: 'rounded-lg bg-white custom-shadow-kd',
            suggestionElement: 'hover:bg-kd-athens-gray text-sm py-2',
            suggestionElementActive: 'bg-kd-athens-gray',
          }}
          autoFocus={!keyword}
        />
        <SearchField
          key="l-input"
          ariaLabel="Location"
          icon="#location"
          name="l"
          id="l"
          placeholder={'City, metro area, or “Remote”'}
          maxLength={100}
          minLength={1}
          value={location}
          onChange={onLocationChange}
          cancelSearch={cancelLocationSearch}
          suggestions={locationSuggestions}
          onSuggestionsClick={onLocationSuggestionsClick}
          isSuggestionsOpened={isLocationsSuggestionsOpened}
          setIsSuggestionsOpened={setIsLocationsSuggestionsOpened}
          className="w-full flex-col"
          classNames={{
            input: `py-3.25 pl-9! px-3 rounded-lg! lg:w-full bg-kd-athens-gray max-md:text-base md:text-sm outline-transparent border border-kd-geyser placeholder-kd-pale-sky focus-visible:border-kd-persimmon focus-visible:bg-white focus-visible:outline-kd-persimmon focus-visible:outline-1`,
            suggestions: 'rounded-lg bg-white custom-shadow-kd',
            suggestionElement: 'hover:bg-kd-athens-gray text-sm py-2',
            suggestionElementActive: 'bg-kd-athens-gray',
          }}
        />
        <button
          className="h-12 flex items-center justify-center px-7 default-transition bg-kd-persimmon rounded-lg font-semibold text-white hover:bg-kd-valencia shrink-0"
          type="submit"
        >
          Search
        </button>
      </form>
      <SelectedFilters
        locations={multipleLocations}
        occupations={occupations}
        industries={industries}
        seniorities={seniorities}
        getRemoveHref={getRemoveFilterHref}
        classNames={{
          label: 'text-kd-mako',
          tag: 'text-kd-mako bg-kd-athens-gray rounded-sm',
          removeIcon: 'text-kd-mako hover:text-kd-woodsmoke',
        }}
      />
    </div>
  );
};

export default SearchFormKD;
